const VIDEO_EXTENSIONS = /\.(mp4|webm|mov|m4v|ogg)([?#].*)?$/i;

export const isVideoUri = (uri: string): boolean => VIDEO_EXTENSIONS.test(uri);
